import type { AskUserQuestionYesOrNo } from "@/api/generated/models";
import {
  type ChoiceValue,
  SingleSelectInline,
} from "@/conversation/AskUserQuestionsPanel/OptionParts";

export default function YesOrNoQuestion({
  value,
  onChange,
  onSubmit,
  onSkip,
  isLast,
}: {
  question: AskUserQuestionYesOrNo;
  value: ChoiceValue;
  onChange: (value: ChoiceValue) => void;
  onSubmit: () => void;
  onSkip: () => void;
  isLast: boolean;
}) {
  return (
    <SingleSelectInline
      options={["Yes", "No"]}
      value={value}
      onChange={onChange}
      onSubmit={onSubmit}
      onSkip={onSkip}
      isLast={isLast}
    />
  );
}
